import ButtonView from "views/button_view";
import ContentSubscriptionIndicatorView from "views/content_subscription_indicator_view";
import i18n from "lib/i18n";
import Minpubsub from "minpubsub";
import { View } from "backbone";

import React from "react";
import ReactDOM from "react-dom";
import ContentCommentManager from "components/Editorial/ContentCommentManager";
/* eslint-disable
    consistent-return,
    func-names,
    max-len,
    no-alert,
    no-cond-assign,
    no-multi-assign,
    no-return-assign,
    no-shadow,
    no-undef,
    no-underscore-dangle,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CommentsActionsView;

export default CommentsActionsView = (function () {
  CommentsActionsView = class CommentsActionsView extends View {
    static initClass() {
      this.prototype.className = "comments-actions-view grid-four grid-last";
      this.prototype.tagName = "div";
    }

    initialize(options) {
      super.initialize(options);
      this.permissions = options.permissions;
      this.contentId = options.contentId;
      this.contentSubscription = options.contentSubscription;
      this.user = options.user;

      if (this.permissions.validate("_renderSignInToCommentButtonView")) { this._renderSignInToCommentButtonView(); }
      if (this.permissions.validate("_renderNewCommentButtonView")) { this._renderNewCommentButtonView(); }
      if (this.permissions.validate("_renderCloseCommentsButtonView")) { this._renderCloseCommentsButtonView(); }
      if (this.permissions.validate("_renderOpenCommentsButtonView")) { this._renderOpenCommentsButtonView(); }
      if (this.permissions.validate("_renderContentSubscriptionIndicatorView")) { this._renderContentSubscriptionIndicatorView(); }
      if (this.permissions.validate("_manageComments") && this.user.hasAccessTo("manage_comments")) { this._renderCommentManager(); }
    }

    _renderSignInToCommentButtonView() {
      this.signInToCommentButtonView = new ButtonView({
        label: i18n.t("comment.button.sign_in_to_comment"),
        className: "comment-sign-in button primary large",
      });

      this.signInToCommentButtonView.$el.appendTo(this.$el);
      return this.signInToCommentButtonView.on("click", () => {
        let returnTo;
        if (returnTo = TC.page != null ? TC.page.content_slug : undefined) {
          return window.location = `sign_in?return_to=/${returnTo}#comments`;
        }
        return window.location = "sign_in";
      });
    }

    _renderNewCommentButtonView() {
      this.newCommentButtonView = new ButtonView({
        label: i18n.t("comment.button.comment_on_this_article"),
        className: "button large primary new",
      });

      this.newCommentButtonView.$el.appendTo(this.$el);
      return this.newCommentButtonView.on("click", () => Minpubsub.publish("comment:new"));
    }

    _renderCloseCommentsButtonView() {
      this.closeCommentsButtonView = new ButtonView({
        label: i18n.t("comment.button.close_comments"),
        className: "button large danger close",
      });

      this.closeCommentsButtonView.$el.appendTo(this.$el);
      return this.closeCommentsButtonView.on("click", () => {
        if (confirm(i18n.t("comment.messages.close_comments"))) { return Minpubsub.publish("comments:close"); }
      });
    }

    _renderOpenCommentsButtonView() {
      this.openCommentsButtonView = new ButtonView({
        label: i18n.t("comment.button.re_open_comments"),
        className: "button large primary open",
      });

      this.openCommentsButtonView.$el.appendTo(this.$el);
      return this.openCommentsButtonView.on("click", () => {
        if (confirm(i18n.t("comment.messages.re_open_comments"))) { return Minpubsub.publish("comments:open"); }
      });
    }

    _renderContentSubscriptionIndicatorView() {
      this.contentSubscriptionIndicatorView = new ContentSubscriptionIndicatorView({
        contentId: this.contentId,
        contentSubscription: this.contentSubscription,
        className: "button large indicator",
      });

      return this.contentSubscriptionIndicatorView.$el.appendTo(this.$el);
    }

    _renderCommentManager() {
      const domContainer = document.createElement("div");
      const container = React.createElement(ContentCommentManager, { contentId: this.contentId });

      ReactDOM.render(container, domContainer);
      this.$el.append(domContainer);
    }
  };
  CommentsActionsView.initClass();
  return CommentsActionsView;
}());
